import React, {
  useRef,
  useState,
  useEffect,
  useContext,
  useCallback,
} from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import classnames from "classnames";
import styles from "@/styles/Breadcrumbs.module.scss";
import IconArrow from "../svgs/icon_arrow.svg";

export const BreadcrumbsContext = React.createContext({
  breadcrumbs: [],
  setBreadcrumbs: () => null,
});
BreadcrumbsContext.displayName = "BreadcrumbsContext";

export function BreadcrumbsProvider({ children }) {
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const router = useRouter();
  const timeoutId = useRef();

  const setBreadcrumbsLazy = useCallback((value) => {
    timeoutId.current = setTimeout(() => {
      setBreadcrumbs(value);
    }, 10);
  }, []);

  useEffect(() => {
    const handleHistoryChange = () => {
      setBreadcrumbs([]);
    };
    router.events.on("routeChangeComplete", handleHistoryChange);
    return () => {
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }
      router.events.off("routeChangeComplete", handleHistoryChange);
    };
  }, []);

  const contextValue = {
    breadcrumbs,
    setBreadcrumbs: setBreadcrumbsLazy,
  };

  return (
    <BreadcrumbsContext.Provider value={contextValue}>
      {children}
    </BreadcrumbsContext.Provider>
  );
}

function Breadcrumbs({ hidden, mobile }) {
  if (hidden) return null;
  const router = useRouter();
  const { breadcrumbs } = useContext(BreadcrumbsContext);
  const fromWatchToTitle = (href) => {
    return href.includes("/title") && router.asPath.includes("/watch");
  };

  return (
    <div
      className={classnames(styles.breadcrumbs, { [styles.mobile]: mobile })}
    >
      <div className={styles.inner}>
        {breadcrumbs.map((breadcrumb, i) => (
          <React.Fragment key={`breadcrumbs-${i}`}>
            {/* watch/{A} → title/{id}(SSR) → watch/{A}の順で遷移した場合、player.refが残るため、リセットする */}
            {breadcrumb.href && fromWatchToTitle(breadcrumb.href) && (
              <a href={breadcrumb.href} className={styles.link}>
                <span title={breadcrumb.text}>{breadcrumb.text}</span>
              </a>
            )}
            {breadcrumb.href && !fromWatchToTitle(breadcrumb.href) && (
              <Link href={breadcrumb.href} className={styles.link}>
                <span title={breadcrumb.text}>{breadcrumb.text}</span>
              </Link>
            )}
            {!breadcrumb.href && (
              <span className={styles.link} title={breadcrumb.text}>
                {breadcrumb.text}
              </span>
            )}
            {breadcrumbs.length != i + 1 && (
              <span className={styles.arrow}>
                <IconArrow />
              </span>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

export default React.memo(Breadcrumbs);

export const BreadcrumbsForFooter = () => {
  const { breadcrumbs } = useContext(BreadcrumbsContext);
  const hidden = breadcrumbs.length == 0;
  return (
    <div
      className={classnames(styles.footerBreadcrumbs, {
        [styles.hidden]: hidden,
      })}
    >
      <Breadcrumbs mobile hidden={hidden} />
    </div>
  );
};
